module.exports = __webpack_public_path__ + "img/sponsor-riviera-logo.b48fe51e.jpg";